<template>
  <div class="table-responsive">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <h3 class="text-center">Paciente origen</h3>
        <DetalleMovimiento :movimiento="traspaso.origen" :fields="fields" /></b-col>
      <b-col>
        <h3 class="text-center">Paciente destino </h3>
        <DetalleMovimiento :movimiento="traspaso.destino" :fields="fields" /></b-col>
    </b-row>
  </div>
</template>

<script>
import DetalleMovimiento from "../movimiento/DetalleMovimiento";
export default {
  name: "DetalleTraspaso",
  components: {DetalleMovimiento},
  props: {
    fields: {type: Array, required: true},
    traspaso: {type: Object, required: true}
  },
  data:() => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>